import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ScreenReaderOnly, Space, TextBody } from '@ally/metronome-ui';
import { PasswordStrength } from '../../constants';
import { determinePasswordStrength } from '../../utils';
const StrengthMeterWrapper = styled.div `
  ${({ theme: { space } }) => `
    margin-top: ${space.md};
    gap: ${space.xxs};
  `}

  display: flex;
`;
const StrengthMeterSegment = styled.div `
  ${({ $color, theme: { colors } }) => {
    return `background-color: ${colors[$color]};`;
}}

  flex: 1;
  height: 4px;
  border-radius: 2px;
`;
const StrengthTextBody = styled(TextBody) `
  ${({ theme: { colors } }) => `
    color: ${colors['gray-700']};
  `}
`;
const StrengthMeter = ({ strength }) => {
    let segmentOneColor = 'page-gray';
    let segmentTwoColor = 'page-gray';
    let segmentThreeColor = 'page-gray';
    switch (strength) {
        case PasswordStrength.Fair:
            segmentOneColor = 'gold-500';
            break;
        case PasswordStrength.Medium:
            segmentOneColor = 'gold-400';
            segmentTwoColor = 'gold-400';
            break;
        case PasswordStrength.Strong:
            segmentOneColor = 'green-400';
            segmentTwoColor = 'green-400';
            segmentThreeColor = 'green-400';
            break;
        case PasswordStrength.None:
        default:
            segmentOneColor = 'page-gray';
            segmentTwoColor = 'page-gray';
            segmentThreeColor = 'page-gray';
    }
    return (React.createElement(StrengthMeterWrapper, { "data-testid": "strength-meter" },
        React.createElement(StrengthMeterSegment, { "$color": segmentOneColor, "data-testid": "strength-meter-segment-one" }),
        React.createElement(StrengthMeterSegment, { "$color": segmentTwoColor, "data-testid": "strength-meter-segment-two" }),
        React.createElement(StrengthMeterSegment, { "$color": segmentThreeColor, "data-testid": "strength-meter-segment-three" })));
};
const PasswordStrengthMeter = ({ password, }) => {
    const [strength, setStrength] = useState(PasswordStrength.None);
    const [shouldShowHint, setShouldShowHint] = useState(false);
    useEffect(() => {
        const newStrength = determinePasswordStrength(password);
        // Only show the hint if the strength if Fair or Medium
        const newShouldShowHint = newStrength === PasswordStrength.Fair ||
            newStrength === PasswordStrength.Medium;
        setStrength(newStrength);
        setShouldShowHint(newShouldShowHint);
    }, [password]);
    return (React.createElement(React.Fragment, null,
        React.createElement(StrengthMeter, { strength: strength }),
        React.createElement(Space, { mt: "xs" },
            React.createElement(StrengthTextBody, { tag: "p", size: "xs", weight: "bold" },
                "Strength: ",
                strength,
                shouldShowHint && (React.createElement(ScreenReaderOnly, null, ". Strong passwords have 15 or more characters (hint, hint).")))),
        shouldShowHint && (React.createElement(Space, { mt: "xs" },
            React.createElement(StrengthTextBody, { tag: "p", size: "xs", "aria-hidden": true }, "Strong passwords have 15 or more characters (hint, hint).")))));
};
export default PasswordStrengthMeter;
//# sourceMappingURL=PasswordStrengthMeter.js.map